import React from "react";

const keyedByRouteParam = (Component, param) => {
  const KeyedByRouteParam = (props) => <Component key={props.match.params[param]} {...props} />;
  return KeyedByRouteParam;
};

export default keyedByRouteParam;
